// extracted by mini-css-extract-plugin
module.exports = {"spinner":"SnakeLoader_spinner__3129i","rotate":"SnakeLoader_rotate__25fEM","bright":"SnakeLoader_bright__1JcTq"};